__turbopack_context__.v({
  "buttonContainer": "HeaderOrderSummary-module__gq0fwG__buttonContainer",
  "cart": "HeaderOrderSummary-module__gq0fwG__cart",
  "chevron": "HeaderOrderSummary-module__gq0fwG__chevron",
  "container": "HeaderOrderSummary-module__gq0fwG__container",
  "containerExpanded": "HeaderOrderSummary-module__gq0fwG__containerExpanded",
  "content": "HeaderOrderSummary-module__gq0fwG__content",
  "costsContainer": "HeaderOrderSummary-module__gq0fwG__costsContainer",
  "entryContainer": "HeaderOrderSummary-module__gq0fwG__entryContainer",
  "expandLink": "HeaderOrderSummary-module__gq0fwG__expandLink",
  "header": "HeaderOrderSummary-module__gq0fwG__header",
  "heading": "HeaderOrderSummary-module__gq0fwG__heading",
  "promoLink": "HeaderOrderSummary-module__gq0fwG__promoLink",
  "promoLinkOpen": "HeaderOrderSummary-module__gq0fwG__promoLinkOpen",
  "promoPanel": "HeaderOrderSummary-module__gq0fwG__promoPanel",
});
